export default "__VITE_ASSET__Di8DWR9q__"